// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2SW4Z","errorLogs":"EditorFooter_errorLogs__3BRZA"};